<template>
  <moe-page>
    <moe-top ref="moeTop"></moe-top>
    <div class="top_banner">
      <el-carousel :interval="4000" arrow="always">
        <el-carousel-item v-for="(image, index) in imageList" :key="index">
          <img :src="imgPath(image)" alt="carousel image" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="hot_sell_course flex Flexjustify Flexalign flexcolumn">
      <div class="hot_sell_course_top FlexBetween flex Flexalign">
        <div class="flex Flexalign">
          <div class="hot_sell_course_top_title">热销好课</div>
        </div>
        <div class="more_btn flex Flexalign Flexjustify">
          更多
          <div class="flex Flexalign" style="margin-left: 5px">
            <el-icon :size="14">
              <ArrowRight />
            </el-icon>
          </div>
        </div>
      </div>
      <courseList :hidePrice="true"></courseList>
    </div>
    <div class="top_box flex Flexjustify Flexalign flexcolumn">
      <div class="filter_box" v-for="(item, index) in filterList" :key="index">
        <div class="flex FlexBetween">
          <div class="flex">
            <div>{{ item.name }}:</div>
            <div v-for="(sitem, sindex) in item.list" :key="sindex" class="area_info">
              {{ sitem.label }}
            </div>
          </div>
          <div class="filter flex Flexalign FlexEvenly" v-if="item.showMore">
            <el-image class="filter_icon" :src="imgPath('filter_icon.png')"></el-image>
            <div>更多</div>
            <el-image class="filter_icon" :src="imgPath('arrow_up.png')"></el-image>
          </div>
        </div>
        <div v-if="item.subList" class="sublist_box flex">
          <div class="opacity_box">{{ item.name }}:</div>
          <div class="flex-1 flex area_box FlexBetween">
            <div class="flex">
              <div class="area_info" v-for="(ssitem, ssindex) in item.subList" :key="ssindex">
                {{ ssitem.label }}
              </div>
            </div>
            <div class="flex more_box Flexalign">
              <div>更多</div>
              <el-image class="filter_icon" :src="imgPath('arrow_up.png')"></el-image>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hot_sell_course flex Flexjustify Flexalign flexcolumn">
      <div class="hot_sell_course_top hot_sell_course_line FlexBetween flex Flexalign">
        <div class="flex Flexalign">
          <div class="hot_sell_course_top_title">会员课程</div>
          <div class="hot_sell_course_top_text flex Flexalign">
            <span>已更新</span>
            <span class="active_text">2530</span>
            <span>个会员课程</span>
          </div>
        </div>
        <div class="more_btn more_btn_border flex Flexalign Flexjustify">
          更多
          <div class="flex Flexalign" style="margin-left: 5px">
            <el-icon :size="14">
              <ArrowRight />
            </el-icon>
          </div>
        </div>
      </div>
      <courseList :hidePrice="true"></courseList>
    </div>
    <div class="member_benefits flex Flexjustify Flexalign">
      <div class="member_benefits_box flex Flexalign FlexAround">
        <div class="flex flexcolumn Flexalign">
          <el-image class="coupon_y_icon" :src="imgPath('coupon_y_icon.png')"></el-image>
          <div class="member_benefits_text">全年1440元礼券</div>
        </div>
        <div class="flex flexcolumn Flexalign">
          <el-image class="coupon_y_icon" :src="imgPath('video_y_icon.png')"></el-image>
          <div class="member_benefits_text">畅学1500+视频</div>
        </div>
        <div class="flex flexcolumn Flexalign">
          <el-image class="coupon_y_icon" :src="imgPath('textbook_y_icon.png')"></el-image>
          <div class="member_benefits_text">配套教材下载</div>
        </div>
        <div class="flex flexcolumn Flexalign">
          <el-image class="coupon_y_icon" :src="imgPath('course_y_icon.png')"></el-image>
          <div class="member_benefits_text">13000元课程免费看</div>
        </div>
      </div>
    </div>
    <div class="bottom_join flex Flexalign Flexjustify">
      <div class="join_box flex Flexalign FlexBetween">
        <div class="flex Flexalign join_text">
          <span>和</span>
          <span class="join_text_bold inline_block join_text_big">98407</span>
          <span>同学一起畅享会员专区课程</span>
          <span class="join_text_bold inline_block continuous">连续包月首月仅</span>
          <span class="join_text_bold inline_block join_text_big">166</span>
          <span class="join_text_bold">元</span>
        </div>
        <div class="btn_join">立即加入</div>
      </div>
    </div>
    <moe-bottom></moe-bottom>
  </moe-page>
</template>

<script>
import courseList from "./components/courseList";
export default {
  name: "GjkcH5MemberArea",

  components: {
    courseList,
  },
  data() {
    return {
      imageList: ["member_top_banner1.png", "member_top_banner2.png", "member_top_banner3.png", "member_top_banner4.png"],
      filterList: [
        {
          name: "地区",
          list: [
            { label: "不限", value: "0" },
            { label: "江宁", value: "1" },
            { label: "浦口", value: "0" },
            { label: "栖霞", value: "0" },
            { label: "鼓楼", value: "0" },
            { label: "秦淮", value: "0" },
            { label: "雨花台", value: "0" },
            { label: "六合", value: "0" },
            { label: "建邺", value: "0" },
            { label: "玄武", value: "0" },
            { label: "溧水", value: "0" },
            { label: "滨江开发区", value: "0" },
            { label: "高淳", value: "0" },
          ],
          subList: [
            { label: "不限", value: "0" },
            { label: "江宁", value: "1" },
            { label: "浦口", value: "0" },
            { label: "栖霞", value: "0" },
            { label: "鼓楼", value: "0" },
            { label: "秦淮", value: "0" },
            { label: "雨花台", value: "0" },
          ],
          showMore: true,
          showFilter: true,
        },
        {
          name: "学段",
          list: [
            { label: "不限", value: "0" },
            { label: "一年级", value: "0" },
            { label: "二年级", value: "1" },
            { label: "三年级", value: "0" },
            { label: "四年级", value: "0" },
            { label: "五年级", value: "0" },
            { label: "六年级", value: "0" },
            { label: "七年级", value: "0" },
            { label: "八年级", value: "0" },
            { label: "九年级", value: "0" },
          ],
        },
        {
          name: "学科",
          list: [
            { label: "不限", value: "0" },
            { label: "语文", value: "0" },
            { label: "数学", value: "1" },
            { label: "英语", value: "0" },
            { label: "化学", value: "0" },
            { label: "思想品德", value: "0" },
          ],
        },
      ],
    };
  },

  mounted() {
    this.topSelectedMenu = this.$Jump.getUrlParams(window.location.hash.split("?")[1]).topSelectedMenu;
    this.$refs.moeTop.topSelectedMenu = this.topSelectedMenu;
  },

  methods: {},
};
</script>
<style lang="scss" scoped>
.top_banner {
  width: 100%;
  height: 350px;

  :deep(.el-carousel__container) {
    height: 350px;
  }
}

.hot_sell_course {
  width: 100%;
  background: #ffffff;
  padding: 30px 0;

  .hot_sell_course_top {
    width: $pageMainWidth;
    padding-top: 20px;

    .hot_sell_course_top_title {
      font-weight: bold;
      font-size: 24px;
      color: #000000;
    }

    .hot_sell_course_top_text {
      color: #666666;
      margin-left: 15px;

      .active_text {
        font-weight: bold;
        font-size: 20px;
        color: #bd8b63;
        display: inline-block;
        padding: 0 5px;
      }
    }

    .hot_course_text {
      color: #999999;
      margin-left: 26px;
    }

    .active_text {
      color: #13d6aa;
    }
  }

  .more_btn {
    width: 70px;
    height: 35px;
  }

  .more_btn_border {
    background: #f5f6f8;
    border-radius: 18px;
    color: rgba(153, 153, 153, 1);
  }
}

.hot_sell_course_line {
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.top_box {
  width: 100%;

  .filter_box {
    width: $pageMainWidth;
    line-height: 32px;
    margin-bottom: 10px;

    .area_info {
      padding: 0 11px;
      box-sizing: border-box;
      margin-left: 10px;
    }

    .filter {
      width: 95px;
      height: 32px;
      border-radius: 5px;
      border: 1px solid #e1e1e1;
      line-height: 32px;

      .filter_icon {
        width: 18px;
        height: 18px;
      }
    }
  }

  .sublist_box {
    margin-top: 10px;

    .opacity_box {
      opacity: 0;
    }

    .area_box {
      margin-left: 10px;
      height: 45px;
      background: #f3f3f3;
      border-radius: 10px;
    }

    .area_info {
      padding: 0 11px;
      box-sizing: border-box;
      margin-left: 10px;
      line-height: 45px;
    }

    .more_box {
      height: 45px;
      margin-right: 10px;
    }

    .filter_icon {
      width: 18px;
      height: 18px;
    }
  }
}

.member_benefits {
  width: 100%;
  height: 200px;
  background: #f3f3f3;

  .member_benefits_box {
    width: $pageMainWidth;

    .coupon_y_icon {
      width: 70px;
      height: 70px;
    }

    .member_benefits_text {
      font-size: 18px;
      color: rgba(189, 139, 99, 0.9);
    }
  }
}

.bottom_join {
  position: fixed;
  bottom: 0;
  bottom: 0;
  width: 100%;
  height: 72px;
  background: #eabf84;

  .join_box {
    width: $pageMainWidth;
    height: 72px;

    .join_text {
      font-size: 22px;
      color: #875427;

      .inline_block {
        display: inline-block;
      }

      .join_text_big {
        font-size: 32px;
        padding: 0 5px;
      }

      .join_text_bold {
        font-weight: 600;
      }

      .continuous {
        margin-left: 25px;
      }
    }

    .btn_join {
      width: 184px;
      height: 48px;
      background: linear-gradient(-89deg, #fffdfa, #fff0d7);
      border-radius: 5px;
      font-weight: 500;
      font-size: 22px;
      color: #875427;
      line-height: 48px;
      text-align: center;
    }
  }
}
</style>